import { render, staticRenderFns } from "./shop_header.vue?vue&type=template&id=553d3c03&scoped=true"
import script from "./shop_header.vue?vue&type=script&lang=js"
export * from "./shop_header.vue?vue&type=script&lang=js"
import style0 from "./shop_header.vue?vue&type=style&index=0&id=553d3c03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553d3c03",
  null
  
)

export default component.exports